import React from 'react';
import Header from '../containers/header/Header'
import Sidemenu from '../containers/sidemenu/Sidemenu'
import View from '../containers/view/View'
import Login from '../containers/login/Login'
import {connect} from 'react-redux'
import login from '../actionCreators/login'
import {bindActionCreators} from 'redux';
import './App.css';

class App extends React.Component {

	componentWillMount() {
		if (document.cookie.indexOf('idtoken') > -1) {
			this.props.login();
		}
	}

	render() { 

		if(this.props.logged) {
			return (
				<div className="App">
					<Header />
					<Sidemenu />
					<View />
				</div>
			);
		}
		else {
			return (
				<div className="App">
					<Header />
					<Login />
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
    return {
        
        logged: state.logged
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({

		login: login

    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js